<script setup lang="ts">
const config = useRuntimeConfig();

</script>

<template>
    <div>
        <div class="fixed w-full top-0 z-50 flex justify-between items-center bg-[#1226AA] px-5 shadow-lg h-20">
            <NuxtLink to="/">
                <img :src="'/img/kosta.png'" alt="KOSTA Logo" class="h-6" />
            </NuxtLink>
            <NuxtLink :to="config.public.kpUrl" class="text-white ">
                <img :src="'/img/kp_logo_white.png'" alt="KP Logo" class="h-6" />
            </NuxtLink>
        </div>
        <div class="pt-20">
            <NuxtPage />
        </div>
    </div>
</template>